// @flow strict

import * as React from 'react'
import cx from 'classnames'

import AccessibilityText from '../AccessibilityText'

import styles from './Tooltip.module.scss'

type Props = $ReadOnly<{|
  label: string,
  description: string,
  link?: string,
  linkText?: string,
  flipped?: boolean,
  id: string,
  className?: string,
  onClick?: () => void,
  showTooltip?: boolean,
|}>

export const Info = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12 2c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10-10-4.4771525-10-10 4.4771525-10 10-10zm0 9c-.5522847 0-1 .4477153-1 1v4c0 .5522847.4477153 1 1 1s1-.4477153 1-1v-4c0-.5522847-.4477153-1-1-1zm0-4c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1 1-.44771525 1-1-.4477153-1-1-1z"
      fill="#14233c"
      fillRule="evenodd"
    />
  </svg>
)

// This tooltip can be entirely CSS-controlled (hover and focus states), or it can be toggled on click (for mobile), in which case whether or not it is displayed is controlled by the parent component.
function Tooltip({
  label,
  description,
  id,
  link,
  linkText,
  flipped = false,
  className,
  onClick,
  showTooltip,
}: Props) {
  return (
    <div className={cx(styles.tooltipContainer, className)}>
      <button
        onClick={onClick != null ? onClick : undefined}
        className={styles.tooltipIcon}
      >
        <AccessibilityText>More information</AccessibilityText>
        <Info />
      </button>
      {(onClick != null && showTooltip) || onClick == null ? (
        <div
          className={cx(styles.tooltip, {
            [styles.flipped]: flipped,
            [styles.cssOnly]: onClick == null,
          })}
          aria-live="assertive"
          role="tooltip"
          id={id}
        >
          {description} {link && <a href={link}>{linkText}</a>}
        </div>
      ) : null}
    </div>
  )
}

export default Tooltip
